var chunkMapping = {
	"4": [
		51623
	],
	"97": [
		93097
	],
	"146": [
		16146
	],
	"152": [
		77152
	],
	"236": [
		67236
	],
	"338": [
		27338
	],
	"472": [
		73472
	],
	"524": [
		68524
	],
	"542": [
		23542
	],
	"640": [
		95640
	],
	"676": [
		61676
	],
	"815": [
		57815
	],
	"845": [
		3845
	]
};
var idToExternalAndNameMapping = {
	"3845": [
		"default",
		"./RequestedMyDataDashboard",
		16076
	],
	"16146": [
		"default",
		"./DataIngest",
		2785
	],
	"23542": [
		"default",
		"./DataIngestList",
		2785
	],
	"27338": [
		"default",
		"./DashboardHighlights",
		16076
	],
	"51623": [
		"default",
		"./AccessRequests",
		16076
	],
	"57815": [
		"default",
		"./RequestedDataDashboard",
		16076
	],
	"61676": [
		"default",
		"./AccessControl",
		16076
	],
	"67236": [
		"default",
		"./App",
		93268
	],
	"68524": [
		"default",
		"./DataProduct",
		16076
	],
	"73472": [
		"default",
		"./MLOps",
		73392
	],
	"77152": [
		"default",
		"./ManageTools",
		82920
	],
	"93097": [
		"default",
		"./RequestedData",
		16076
	],
	"95640": [
		"default",
		"./AccessApproval",
		16076
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}